import { render } from "./ImportDetailInformationTab.vue?vue&type=template&id=f2242e94&scoped=true"
import script from "./ImportDetailInformationTab.vue?vue&type=script&lang=js"
export * from "./ImportDetailInformationTab.vue?vue&type=script&lang=js"

import "./ImportDetailInformationTab.vue?vue&type=style&index=0&id=f2242e94&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2242e94"]])

export default __exports__